import { IRegionGroup } from '@/models';
import { get } from '../axiosprovider';

const getRegions = async (): Promise<IRegionGroup[]> => {
	return await get('/api/regions');
};

export const regionsController = {
	getRegions
};
